export default "__VITE_ASSET__X4$yswjo__"